import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleOrder from './SingleOrder';
import DateFilter from '../../elements/DateFilter';

import TopBarValues from './topBarValues';
import Filters from './Filters';
import { allProductTypesAction, clearErrors } from '../../redux/actions/userActions';
import Loader from '../loader/loader';
import { CREATE_ORDER_RESET } from '../../redux/constants/orderConstants';



/*************  ✨ Windsurf Command 🌟  *************/  
const IncomingCommission = () => {



    const dispatch = useDispatch()
    const { productTypes } = useSelector(state => state.allProductTypes);


    const { loading,
        orders,
        totalPages,
        commissionedCount,
    } = useSelector((state) => state.orders)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: orderLoading, error, message } = useSelector(state => state.order)




    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [pmmCommission, setPmmCommission] = useState(0);
    const [portalCommission, setPortalCommission] = useState(0);



    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())
        document.title = "Incoming Commission";


    }, [dispatch])






    useEffect(() => {


        if (error) {
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
        }

    }, [error, message, dispatch])



    useEffect(() => {


        if (orders?.length > 0) {

            let pmmTotal = 0;
            let portalTotal = 0;

            orders.forEach((order) => {

                pmmTotal = pmmTotal + Number(order?.pm_commission_amount) || 0;
                portalTotal = portalTotal + Number(order?.portal_commission_amount) || 0;
            })

            setPmmCommission(pmmTotal);
            setPortalCommission(portalTotal);
        }


    }, [orders])





    return (
        <Fragment>
            {orderLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={user?.role !== "PMM" ? "Incoming Commission" : "Payment History"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                <TopBarValues
                    commissionedCount={commissionedCount}
                    pmmCommission={pmmCommission}
                    portalCommission={portalCommission}
                    totalOrders={orders?.length}

                />
                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                <div className="bg-white p-[2vmax] lg:mt-[-2vmax]  shadow-1 rounded-b-lg overflow-x-auto my-scroll-2 my-scroll-3">

                    <div className="flex w-[250%] lg:w-full mt-[2vmax] bg-gray-200 py-[0.5vmax] items-center rounded-2xl">
                        <div className="text-center flex-[1] min-w-[80px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            Order ID
                        </div>
                        <div className="px-[0.5vmax] flex-[1] min-w-[100px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            Product ID
                        </div>

                        {user?.role !== "PMM" &&
                            <div className="text-center px-[0.5vmax] flex-[1] min-w-[120px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Received from
                            </div>
                        }

                        <div className="text-center px-[0.5vmax] flex-[1] min-w-[120px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            {user?.role !== "PMM" ?
                                "Amount Received"
                                :
                                "Amount PAID"
                            }
                        </div>
                        <div className="text-center px-[0.5vmax] flex-[1.5] min-w-[150px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            Commissioned At
                        </div>

                        <div className="text-center px-[0.5vmax] flex-[1.5] min-w-[130px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            Status
                        </div>

                        <div className="text-center px-[0.5vmax] flex-[1] min-w-[100px] text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                            Actions
                        </div>
                    </div>
                    {loading ?
                        <LoaderBlock />
                        :
                        orders?.length > 0 ?
                            orders.map((order, index) =>
                                <>
                                    <SingleOrder key={order.id} order={order} user={user} productTypes={productTypes}
                                    />

                                </>
                            )


                            :
                            <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                No data found
                            </div>
                    }

                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default IncomingCommission